<template>
  <el-table-column
    v-bind="$attrs"
    :label="label"
    align="center"
    class-name="txn-field"
    >
    <template slot-scope="scope">
      <el-popover
        v-if="scope.row && scope.row['txn_id'] !== null"
        trigger="click"
        >
        <el-table
          :data="getData(scope.row)"
          :show-header="false"
          row-class-name="popover-field"
          >
          <el-table-column
            prop="name"
            align="center"
            width="120"
            >
          </el-table-column>
          <el-table-column
            prop="data"
            width="200"
            >
            <template slot-scope="scope">
              <div
                class="allow-click-copy"
                @click="doCopy(scope.row['data'])"
                >
                {{ scope.row['data'] }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-button
          slot="reference"
          :type="getButtonType(scope.row)"
          circle
          >
          <svg-icon icon-class="baseline-credit_card-24px"></svg-icon>
        </el-button>
      </el-popover>
    </template>
  </el-table-column>
</template>

<script>

import { doCopy } from '@/utils/copy'
import { getMap, getTransText } from '@/utils/i18n'
import { getTimeText } from '@/utils/time'

export default {
  name: 'txn-field',
  props: {
    value: null,
    base: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    label () {
      return this.getTransText(this.name, 'label', this.base)
    }
  },
  methods: {
    doCopy,
    getMap,
    getTimeText,
    getTransText,
    getButtonType (row) {
      if (row.sales_mode === 4 && row.txn_cap_time === null) {
        return 'danger'
      }
      return ''
    },
    getCard (data) {
      let bin = data['txn_card_bin_code'] || ''
      let four = data['txn_card_lastfour'] || ''
      return bin + '-' + four
    },
    getName (name) {
      return this.$t('api.txn.fields.' + name + '.label')
    },
    getData (data) {
      if (!data['txn_id']) {
        return []
      }
      let status = this.getMap('status', 'txn').filter(function (el) {
        return el.value === data['txn_status']
      })
      let type = this.getMap('txnType', 'txn').filter(function (el) {
        return el.value === data['txn_type']
      })
      let arr = [{
        name: this.getName('status'),
        data: status[0] ? status[0].label : ''
      }, {
        name: this.getName('type'),
        data: type[0] ? type[0].label : ''
      }, {
        name: this.getName('trade_id'),
        data: data['txn_ex_trade_id']
      }, {
        name: this.getName('authcode'),
        data: data['txn_auth_code']
      }, {
        name: this.getName('acquirer'),
        data: data['txn_acquirer']
      }, {
        name: this.getName('card'),
        data: this.getCard(data)
      }, {
        name: this.getName('card_country'),
        data: data['txn_card_country']
      }, {
        name: this.getName('card_issuer'),
        data: data['txn_card_issuer']
      }, {
        name: this.getName('cost_ms'),
        data: data['txn_cost_milli_sec']
      }]
      if (data['sales_mode'] === 4) {
        let t = (data['txn_cap_time'] !== null) ? this.getTimeText(data['txn_cap_time'], true) : '-'
        arr.push({
          name: this.getName('cap_time'),
          data: t
        })
      }
      return arr
    }
  }
}
</script>
